import {EnvEventPutDataTransferObject} from "../../data-transfer-object/env/EnvEventPutDataTransferObject"

/**
 * 이벤트 속성 설명
 */
export const EnvEventPutDataTransferObjectDescription: Record<keyof EnvEventPutDataTransferObject, string> = {
    title: '제목',
    url: 'URL'
}
